import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = (data) => api.post('/leads', data).then((r) => r.data);
export const submitBooking = (data) => api.post('/bookings', data).then((r) => r.data);
export const fetchBookingCounts = () => api.get('/bookings/counts').then((r) => r.data);
export const submitGuideOptin = (data) => api.post('/guide-optin', data).then((r) => r.data);
export const guideDownloadUrl = (email) => `${API}/guide/download?email=${encodeURIComponent(email || '')}`;

export const createSubscription = (data) => api.post('/subscriptions', data).then((r) => r.data);
export const approvedVideoTestimonials = () => api.get('/testimonial-videos/approved').then((r) => r.data);
export const videoMediaUrl = (id) => `${API}/testimonial-videos/${id}/media`;
export const uploadVideoTestimonial = (formData, onProgress) =>
  api.post('/testimonial-videos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => onProgress?.(Math.round((e.loaded * 100) / (e.total || 1))),
  }).then((r) => r.data);

// Admin
export const verifyPasscode = (passcode) => api.post('/admin/verify', { passcode }).then((r) => r.data);
const adminHeaders = (passcode) => ({ headers: { 'x-admin-passcode': passcode } });
export const adminLeads = (passcode) => api.get('/leads', adminHeaders(passcode)).then((r) => r.data);
export const adminBookings = (passcode) => api.get('/bookings', adminHeaders(passcode)).then((r) => r.data);
export const adminGuideOptins = (passcode) => api.get('/guide-optins', adminHeaders(passcode)).then((r) => r.data);
export const adminDeleteLead = (passcode, id) => api.delete(`/leads/${id}`, adminHeaders(passcode)).then((r) => r.data);
export const adminSubscriptions = (passcode) => api.get('/subscriptions', adminHeaders(passcode)).then((r) => r.data);
export const adminCancelSubscription = (passcode, id) => api.post(`/subscriptions/${id}/cancel`, {}, adminHeaders(passcode)).then((r) => r.data);
export const adminVideos = (passcode) => api.get('/testimonial-videos', adminHeaders(passcode)).then((r) => r.data);
export const adminModerateVideo = (passcode, id, action) => api.post(`/testimonial-videos/${id}/${action}`, {}, adminHeaders(passcode)).then((r) => r.data);
